import { render, staticRenderFns } from "./GoodBye.vue?vue&type=template&id=ed8f489e&scoped=true"
import script from "./GoodBye.vue?vue&type=script&lang=js"
export * from "./GoodBye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8f489e",
  null
  
)

export default component.exports